import spCommentTemplate from './spcomments.html';

angular
   .module('org.saga.widget.spcomments', [
      'org.saga.service',
      'org.saga.spprioritycomment',
      'org.saga.spcommentsettlement'
   ])
   .directive('spcommentsWidget', [
      'PropertiesLoader',
      '$translate',
      'InstanceExpression',
      'SpPriorities',
      'SpComments',
      'SpActivities',
      'SpBudgetItems',
      'Utils',
      function (
         PropertiesLoader,
         $translate,
         InstanceExpression,
         SpPriorities,
         SpComments,
         SpActivities,
         SpBudgetItems,
         Utils
      ) {
         return {
            restrict: 'E',
            require: '^form',
            controllerAs: 'ctrl',
            template: spCommentTemplate,
            scope: {
               widget: '=',
               editable: '=',
               instance: '=',
               required: '=',
               output: '=?'
            },
            controller: [
               '$scope',
               '$parse',
               '$mdDialog',
               'DefaultProperties',
               'SpPriorityCommentDialog',
               'SpCommentSettlementDialog',
               function (
                  $scope,
                  $parse,
                  $mdDialog,
                  DefaultProperties,
                  SpPriorityCommentDialog,
                  SpCommentSettlementDialog
               ) {
                  PropertiesLoader.load($scope, DefaultProperties.spcomments);
                  $scope.loading = false;

                  function getValueFromAttribute(attribute) {
                     return InstanceExpression.eval(attribute, $scope.instance);
                  }

                  $scope.processId = getValueFromAttribute($scope.processId);
                  $scope.socialPartnerId = getValueFromAttribute($scope.socialPartnerId);
                  $scope.commentCreatorEmail = getValueFromAttribute($scope.commentCreatorEmail);
                  $scope.commentCreatorName = getValueFromAttribute($scope.commentCreatorName);
                  $scope.commentCreatorDepartment = getValueFromAttribute(
                     $scope.commentCreatorDepartment
                  );
                  $scope.commentResolverEmail = getValueFromAttribute($scope.commentResolverEmail);
                  $scope.commentResolverName = getValueFromAttribute($scope.commentResolverName);
                  $scope.commentsFilter = getValueFromAttribute($scope.commentsFilter);

                  function getObjectType() {
                     switch ($scope.type) {
                        case 'COMMENT_PRIORITY':
                        case 'NOTICE_PRIORITY':
                           return 'PRIORITY';
                        case 'COMMENT_ACTIVITY':
                        case 'NOTICE_ACTIVITY':
                           return 'ACTIVITY';
                        default:
                           return null;
                     }
                  }

                  function getCommentType() {
                     switch ($scope.type) {
                        case 'COMMENT_ACTIVITY':
                        case 'COMMENT_PRIORITY':
                           return 'COMMENT';
                        case 'NOTICE_ACTIVITY':
                        case 'NOTICE_PRIORITY':
                           return 'NOTICE';
                        default:
                           return null;
                     }
                  }

                  function getComments() {
                     $scope.loading = true;
                     const objectType = getObjectType();
                     let filters = {
                        filter_type: 'AND',
                        filters: [
                           { type: 'equal', field: 'processId', value: $scope.processId },
                           {
                              type: 'equal',
                              field: 'socialPartnerId',
                              value: $scope.socialPartnerId
                           },
                           { type: 'equal', field: 'commentType', value: getCommentType() },
                           ...$scope.commentsFilter
                        ],
                        groups: [
                           {
                              filter_type: 'OR',
                              filters: [
                                 { type: 'equal', field: 'commentObjectType', value: 'GENERAL' }
                              ],
                              groups: []
                           }
                        ]
                     };

                     if (objectType === 'PRIORITY') {
                        filters.groups[0].filters.push({
                           type: 'equal',
                           field: 'commentObjectType',
                           value: 'PRIORITY'
                        });
                     } else if (objectType === 'ACTIVITY') {
                        filters.groups[0].filters.push(
                           {
                              type: 'equal',
                              field: 'commentObjectType',
                              value: 'ACTIVITY'
                           },
                           {
                              type: 'equal',
                              field: 'commentObjectType',
                              value: 'BUDGET_ITEM'
                           }
                        );
                     }

                     SpComments.fetch({
                        filters: JSON.stringify(filters)
                     })
                        .$promise.then(function (response) {
                           $scope.loading = false;
                           $scope.output = angular.copy(response.results);
                           $scope.reloadKey = Date.now(); // Force re-render of ng-repeat
                        })
                        .catch(function () {
                           $scope.loading = false;
                           $scope.output = [];
                        });
                  }

                  getComments();

                  function showErrorDialog(error) {
                     $mdDialog.show(
                        $mdDialog
                           .alert()
                           .clickOutsideToClose(true)
                           .title('Chyba')
                           .textContent(
                              'Při pokusu o ukládání dat došlo k chybě' + '\n' + error.data.message
                           )
                           .ok($translate.instant('Ok'))
                     );
                  }

                  $scope.deleteComment = function (commentRowId) {
                     SpComments.delete({ row_id: commentRowId })
                        .$promise.then(function () {
                           getComments();
                        })
                        .catch(function (error) {
                           showErrorDialog(error);
                        });
                  };

                  function createPriorityUploadData(priority) {
                     return {
                        processId: priority.processId,
                        priorityName: priority.priorityName,
                        priorityGoal: priority.priorityGoal,
                        priorityDescription: priority.priorityDescription,
                        socialPartnerId: priority.socialPartnerId
                     };
                  }

                  function createActivityPayload(activity) {
                     return {
                        processId: activity.processId,
                        socialPartnerId: activity.socialPartnerId,
                        activityName: activity.activityName,
                        activityFrom: activity.activityFrom,
                        activityTo: activity.activityTo,
                        activityDescription: activity.activityDescription,
                     }
                  }

                  function createBudgetItemPayload(budgetItem) {
                     return {
                        processId: budgetItem.processId,
                        socialPartnerId: budgetItem.socialPartnerId,
                        budgetType: budgetItem.budgetType,
                        activityId: budgetItem.activityId,
                        costType: budgetItem.costType,
                        costName: budgetItem.costName,
                        costRate: budgetItem.costRate,
                        costMonthUnit: budgetItem.costMonthUnit,
                        collectiveSupportingCost: budgetItem.collectiveSupportingCost,
                     }
                  }

                  function updateComment(comment) {
                     SpComments.update({ row_id: comment.id }, comment)
                        .$promise.then(function () {
                           getComments();
                        })
                        .catch(function (error) {
                           showErrorDialog(error);
                        });
                  }

                  function getLinkedDataPromise (comment) {
                     let promise;
                     if (comment.linkToPriority[0]) {
                        promise = SpPriorities.fetchById({
                           row_id: comment.linkToPriority[0].id
                        }).$promise;
                     } else if (comment.linkToActivity[0]) {
                        promise = SpActivities.fetchById({
                           row_id: comment.linkToActivity[0].id
                        }).$promise;
                     } else if (comment.linkToBudgetItem[0]) {
                        promise = SpBudgetItems.fetchById({
                           row_id: comment.linkToBudgetItem[0].id
                        }).$promise;
                     } else {
                        promise = Promise.resolve(null);
                     }
                     return promise;
                  }

                  $scope.editComment = function (comment) {
                     const commentToEdit = angular.copy(comment);
                     const promise = getLinkedDataPromise(commentToEdit);

                     promise
                        .then(function (response) {
                           let priority = null;
                           let activity = null;
                           let budgetItem = null;

                           if (response && response.shortPriorityId) {
                              priority = response;
                           } else if (response && response.shortActivityId) {
                              activity = response;
                           } else if (response && response.shortBudgetItemId) {
                              budgetItem = response;
                           }

                           return SpPriorityCommentDialog.show(
                              priority,
                              commentToEdit,
                              getCommentType(),
                              (editedComment) => {
                                 const data = {
                                    id: editedComment.id,
                                    commentSeverity: editedComment.commentSeverity,
                                    commentDescription: editedComment.commentDescription,
                                    commentSettlementDecision:
                                       editedComment.commentSettlementDecision
                                 };
                                 updateComment(data);
                              },
                              activity,
                              budgetItem
                           );
                        })
                        .catch(function (error) {
                           console.log('Error fetching linked priority: ', error);
                        });
                  };

                  function getNewComment() {
                     return {
                        commentSeverity: null,
                        commentDescription: null,
                        commentSettlementDecision: null,
                        commentObjectType: 'GENERAL',
                        commentObjectId: null,
                        commentCreatorEmail: $scope.commentCreatorEmail,
                        commentCreatorName: $scope.commentCreatorName,
                        commentCreatorDepartment: $scope.commentCreatorDepartment,
                        commentResolverEmail: $scope.commentResolverEmail,
                        commentResolverName: $scope.commentResolverName,
                        resolverNote: null,
                        commentType: getCommentType(),
                        processId: $scope.processId,
                        socialPartnerId: $scope.socialPartnerId
                     };
                  }

                  $scope.addComment = function () {
                     if (
                        !$scope.commentCreatorEmail ||
                        !$scope.commentCreatorName ||
                        !$scope.commentCreatorDepartment
                     ) {
                        console.log(
                           'Missing commentCreatorEmail or commentCreatorName or commentCreatorDepartment, cannot add comment'
                        );
                        return;
                     }

                     const comment = getNewComment();
                     const priority = null;
                     SpPriorityCommentDialog.show(
                        priority,
                        comment,
                        getCommentType(),
                        (comment) => {
                           SpComments.create(comment)
                              .$promise.then(function () {
                                 getComments();
                              })
                              .catch(function (error) {
                                 showErrorDialog(error);
                              });
                        }
                     );
                  };

                  function showSettlementDialog(priority, activity, budgetItem, comment) {
                     SpCommentSettlementDialog.show(
                        priority,
                        activity,
                        budgetItem,
                        comment,
                        getCommentType(),
                        (response) => {
                           const { priority, activity, budgetItem, comment } = response;

                           if (priority) {
                              const data = createPriorityUploadData(priority);
                              SpPriorities.update({ row_id: priority.id }, data)
                                 .$promise.then(function () {
                                    console.log('Priority updated successfully');
                                 })
                                 .catch(function (error) {
                                    console.log('Error updating priority: ', error);
                                 });
                           }

                           if (activity) {
                              const payload = createActivityPayload(activity);
                              SpActivities.update({ row_id: activity.id }, payload)
                                 .$promise.then(function () {
                                 console.log('Activity updated successfully');
                              })
                              .catch(function (error) {
                                 console.log('Error updating activity: ', error);
                              })
                           }

                           if (budgetItem) {
                              const payload = createBudgetItemPayload(budgetItem);
                              SpBudgetItems.update({row_id: budgetItem.id}, payload)
                                 .$promise.then(function () {
                                 console.log('Budget item updated successfully');
                              })
                                 .catch(function (error) {
                                    console.log('Error updating budget item: ', error);
                                 })
                           }

                           const data = {
                              id: comment.id,
                              resolverNote: comment.resolverNote,
                              commentResolverEmail: comment.commentResolverEmail,
                              commentResolverName: comment.commentResolverName
                           };
                           updateComment(data);
                        }
                     );
                  }

                  $scope.settle = function (comment) {
                     if (!$scope.commentResolverName || !$scope.commentResolverEmail) {
                        console.log(
                           'Missing commentResolverName or commentResolverEmail, cannot settle comment'
                        );
                        return;
                     }

                     const commentToEdit = angular.copy(comment);
                     commentToEdit.commentResolverEmail = $scope.commentResolverEmail;
                     commentToEdit.commentResolverName = $scope.commentResolverName;

                     const promise = getLinkedDataPromise(commentToEdit);

                     promise
                        .then(function (response) {
                           let priority = null;
                           let activity = null;
                           let budgetItem = null;

                           if (response && response.shortPriorityId) {
                              priority = response;
                           } else if (response && response.shortActivityId) {
                              activity = {
                                 id: response.id,
                                 activityName: response.activityName,
                                 activityFrom: new Date(response.activityFrom),
                                 activityTo: new Date(response.activityTo),
                                 activityDescription: response.activityDescription,
                                 processId: response.processId,
                                 socialPartnerId: response.socialPartnerId
                              };
                           } else if (response && response.shortBudgetItemId) {
                              budgetItem = {
                                 id: response.id,
                                 budgetType: response.budgetType,
                                 activityId: response.activityId,
                                 costType: response.costType,
                                 costName: response.costName,
                                 costRate: Number(response.costRate),
                                 costMonthUnit: Number(response.costMonthUnit),
                                 collectiveSupportingCost: Number(response.collectiveSupportingCost),
                                 processId: response.processId,
                                 socialPartnerId: response.socialPartnerId,
                              };
                           }

                           return showSettlementDialog(priority, activity, budgetItem, commentToEdit);
                        })
                        .catch(function (error) {
                           console.log('Error fetching linked priority: ', error);
                        });
                  };

                  $scope.accept = function (commentId) {
                     const data = {
                        id: commentId,
                        commentSettlementDecision: 'ACCEPTED'
                     };
                     updateComment(data);
                  };

                  $scope.deny = function (comment) {
                     const commentToEdit = angular.copy(comment);
                     commentToEdit.commentSettlementDecision = 'DENIED';

                     $scope.editComment(commentToEdit);
                  };

                  let timeoutContext = { timeout: null };

                  angular.forEach($scope.watching, function (w) {
                     $scope.$watch(
                        'instance.attributes.' + w,
                        Utils.lateWatch(timeoutContext, 200, getComments)
                     );
                  });
               }
            ]
         };
      }
   ]);
